var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M48 88C70.0914 88 88 70.0914 88 48C88 25.9086 70.0914 8 48 8C25.9086 8 8 25.9086 8 48C8 70.0914 25.9086 88 48 88Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 64V48","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M48 32H48.04","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Info.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Info;

Info.default = Info;
